import { render, staticRenderFns } from "./WhatsHappeningEntriesBox.vue?vue&type=template&id=07341362&"
import script from "./WhatsHappeningEntriesBox.vue?vue&type=script&lang=js&"
export * from "./WhatsHappeningEntriesBox.vue?vue&type=script&lang=js&"
import style0 from "./WhatsHappeningEntriesBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports